import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`stock-adjustments`);
  return response.data;
};
export const getSource = async () => {
  const response = await instance.get(`stock-adjustments/getSource`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`stock-adjustments`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`stock-adjustments`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`stock-adjustments/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`stock-adjustments/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`stock-adjustments/password`, data);
  return response;
};
